import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getUnApprovedCustomerDetails,
    GetUnApprovedCustomerDetailsModel,
    GetUnApprovedCustomerDetailsParameter,
} from "@tSurya/Services/SurGetCustomPropertiesService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<GetUnApprovedCustomerDetailsParameter, GetUnApprovedCustomerDetailsModel>;

export const DispatchBeginUnApprovedCustomerDetails: HandlerType = props => {
    props.dispatch({
        type: "Custom/UnApprovedCustomerDetails/BeginLoadCUnApprovedCustomer",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getUnApprovedCustomerDetails(props.apiParameter);
};

export const DispatchCompleteUnApprovedCustomerDetails: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/UnApprovedCustomerDetails/CompletedLoadUnApprovedCustomer",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginUnApprovedCustomerDetails,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteUnApprovedCustomerDetails,
];

const loadUnApprovedCustomerDetails = createHandlerChainRunner(chain, "loadUnApprovedCustomerDetails");
export default loadUnApprovedCustomerDetails;
